import { Button, Dropdown, MenuProps } from 'antd';
import { useState } from 'react';
import { ReactComponent as DownloadListIcon } from "../../assets/svgs/icons/download-list-icon.svg";
import { ReactComponent as CloudDownloadIcon } from "../../assets/svgs/icons/cloud-download-icon.svg";
import { ReactComponent as DownloadIcon } from "../../assets/svgs/icons/download-icon.svg";
import { DownOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';

const downloadMenuItems: MenuProps['items'] = [
    {
        label: 'Download List',
        key: '1',
        icon: <DownloadListIcon />,
    },
    {
        label: 'Quick Download',
        key: '2',
        icon: <DownloadIcon />,
    },
];

interface AOIHeaderMenuProps {
    initAddingAOI: (isQuickDownload: boolean) => void;
}

const DownloadHeaderMenu = ({ initAddingAOI }: AOIHeaderMenuProps) => {
    const navigate = useNavigate();

    const handleToolsMenuClick = ({ key }: { key: string }) => {
        switch (key) {
            case '1':
                navigate('/downloads')
                break;
            case '2':
                initAddingAOI(true)
                break;
            default:
        }
    };
    const downloadMenuProps = {
        items: downloadMenuItems,
        onClick: handleToolsMenuClick,
    };

    return (
        <>
            <Dropdown menu={downloadMenuProps} overlayClassName="menu_dropdown">
                <Button className='menu_button'>
                    <CloudDownloadIcon key="CloudDownloadIcon" className='menu_icon' />
                    Download
                    <DownOutlined />
                </Button>
            </Dropdown>
        </>
    );
}

export default DownloadHeaderMenu;
